/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestionOption {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestionOption.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestionOption>): AppSecopsBCSQuestionOption {
        let obj = Object.assign(new AppSecopsBCSQuestionOption(), model);
        AppSecopsBCSQuestionOption.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestionOption>): AppSecopsBCSQuestionOption {
        if (!model) return null;
        return AppSecopsBCSQuestionOption.newInstance(<AppSecopsBCSQuestionOption> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestionOption) {
        if (!obj) return;

        models.AppSecopsBCSQuestionOption.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestionOption): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestionOption.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.value === undefined) {
            this.value = 0;
        }
    }

    /**
     * Option ID
     */
    id: string;

    /**
     * Option label
     */
    label: string;

    /**
     * Answer value for scoring
     */
    value: number;

    /**
     * Mutually exclusive None option (Q6)
     */
    is_none: boolean;

    /**
     * High-tier regulatory framework flag (Q6)
     */
    high_tier: boolean;

    /**
     * Whether selecting this option pre-fills Q5a to High (Q11)
     */
    prefill_q5a: boolean;

}
